import type { WaitlistSubmitPayload, WaitlistSubmitResponse } from "@/types/waitlist";

import type { APIInstance } from "./apiService";

export class WaitlistService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async submit(payload: WaitlistSubmitPayload): Promise<WaitlistSubmitResponse> {
    const response = await this.api.post<WaitlistSubmitResponse>("/public/waitlist", payload);
    return response.data;
  }
}
